  window.WMFKNJ = window.WMFKNJ || {};
  window.WMFKNJ.Header = (function() {
    var header, menuBtn, drawer, mega, backdrop, drawerLinks, isOpen = false, activeChildPanel = null;
    var scrollLastY = 0;
    var scrollTicking = false;
    var scrollBound = false;
    var abortController = null;
    var cartListenersBound = false;
    var headerHeightResizeTimer = 0;

    function isDesktop() {
      return window.matchMedia('(min-width: 1025px)').matches;
    }

    function getFocusable(container) {
      if (!container) return [];
      return Array.from(container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])'
      )).filter(function(el) { return el.offsetParent !== null; });
    }

    function getScrollY() {
      var page = document.querySelector('.page-wrapper');
      if (page && typeof page.scrollTop === 'number' && page.scrollHeight > page.clientHeight + 40) {
        return page.scrollTop;
      }
      return window.scrollY || document.documentElement.scrollTop || 0;
    }

    function getScrollTarget() {
      var page = document.querySelector('.page-wrapper');
      if (page && page.scrollHeight > page.clientHeight + 40) return page;
      return window;
    }

    function trapDrawerFocus(e) {
      if (!isOpen || e.key !== 'Tab' || !drawer || isDesktop()) return;
      var panel = activeChildPanel || drawer.querySelector('[data-drawer-panel="main"]');
      var nodes = getFocusable(panel);
      if (nodes.length < 2) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function syncMegaA11y(openState) {
      if (!mega) return;
      mega.setAttribute('aria-hidden', openState && isDesktop() ? 'false' : 'true');
      mega.querySelectorAll('a, button').forEach(function(el) {
        if (openState && isDesktop()) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }

    function open() {
      isOpen = true;
      if (window.WMFKNJ.Search && window.WMFKNJ.Search.closeHeader) {
        window.WMFKNJ.Search.closeHeader();
      }
      header.setAttribute('data-menu-open', '');
      header.setAttribute('data-scroll-state', 'visible');
      if (drawer) drawer.classList.remove('active');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      if (drawer) drawer.setAttribute('aria-hidden', isDesktop() ? 'true' : 'false');
      syncMegaA11y(true);

      /* Lock scroll only for mobile drawer — desktop mega stays over page */
      if (!isDesktop()) {
        document.body.style.overflow = 'hidden';
        drawerLinks.forEach(function(l) { l.setAttribute('tabindex', '0'); });
        // Never autofocus search — that opens the mobile keyboard.
        // Prefer first drawer nav link; fall back to menu button.
        var panel = activeChildPanel || (drawer && drawer.querySelector('[data-drawer-panel="main"]'));
        var focusables = getFocusable(panel).filter(function (el) {
          return !(el.matches && (el.matches('input, textarea, [contenteditable="true"]') || el.closest('.rz-search, [data-rz-search-root]')));
        });
        var first = focusables[0];
        if (first) first.focus({ preventScroll: true });
        else if (menuBtn) menuBtn.focus({ preventScroll: true });
        if (drawer) {
          drawer.querySelectorAll('.rz-search__input, input[type="search"], input[type="text"]').forEach(function (inp) {
            try { inp.blur(); } catch (_) {}
          });
        }
      } else if (mega) {
        var megaFirst = getFocusable(mega).filter(function (el) {
          return !(el.matches && el.matches('input, textarea'));
        })[0];
        if (megaFirst) megaFirst.focus({ preventScroll: true });
      }
    }

    function close(opts) {
      opts = opts || {};
      isOpen = false;
      closeChildPanel();
      header.removeAttribute('data-menu-open');
      if (drawer) drawer.classList.remove('active');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      syncMegaA11y(false);
      drawerLinks.forEach(function(l) { l.setAttribute('tabindex', '-1'); });
      document.body.style.overflow = '';
      if (opts.focusMenu && menuBtn) {
        try { menuBtn.focus({ preventScroll: true }); } catch (_) {}
      }
    }

    function closeAllChrome() {
      close();
      if (window.WMFKNJ.Search && typeof window.WMFKNJ.Search.closeHeader === 'function') {
        window.WMFKNJ.Search.closeHeader();
      }
      if (header) {
        header.querySelectorAll('[data-nav-parent].is-open').forEach(function(p) {
          p.classList.remove('is-open');
          var t = p.querySelector('[data-submenu-toggle]');
          var s = p.querySelector('[data-submenu]');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (s) s.setAttribute('aria-hidden', 'true');
        });
        header.removeAttribute('data-search-open');
      }
    }

    function toggle() { isOpen ? close({ focusMenu: true }) : open(); }

    function onScrollHide() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function() {
        scrollTicking = false;
        if (!header) return;
        var y = getScrollY();
        if (y <= 20) {
          header.setAttribute('data-scroll-state', 'top');
        } else if (y > scrollLastY + 4 && y > 72) {
          header.setAttribute('data-scroll-state', 'hidden');
          if (isOpen) close();
        } else if (y < scrollLastY - 4) {
          header.setAttribute('data-scroll-state', 'visible');
        }
        scrollLastY = y;
      });
    }

    function publishHeaderHeights() {
      if (!header) return;
      var headerGroup = document.getElementById('header-group');
      var headerHeight = header.offsetHeight;
      document.body.style.setProperty('--header-height', headerHeight + 'px');
      if (headerGroup) {
        var headerGroupHeight = 0;
        for (var i = 0; i < headerGroup.children.length; i++) {
          var child = headerGroup.children[i];
          if (child instanceof HTMLElement) headerGroupHeight += child.offsetHeight;
        }
        document.body.style.setProperty('--header-group-height', headerGroupHeight + 'px');
      }
      var headerTopRow = header.querySelector('.rz-header__inner');
      if (headerTopRow) {
        document.body.style.setProperty('--top-row-height', headerTopRow.offsetHeight + 'px');
      }
    }

    function scheduleHeaderHeights() {
      publishHeaderHeights();
      requestAnimationFrame(function () {
        requestAnimationFrame(publishHeaderHeights);
      });
    }

    function teardown() {
      stopCartShake();
      scrollBound = false;
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
      clearTimeout(headerHeightResizeTimer);
    }

    function initScrollHide(signal) {
      if (scrollBound) return;
      scrollBound = true;
      header.setAttribute('data-scroll-state', 'top');
      scrollLastY = getScrollY();
      var target = getScrollTarget();
      var opts = { passive: true, signal: signal };
      target.addEventListener('scroll', onScrollHide, opts);
      if (target !== window) {
        window.addEventListener('scroll', onScrollHide, opts);
      }
    }

    function onPointerDownOutside(e) {
      if (!isOpen) return;
      if (menuBtn && menuBtn.contains(e.target)) return;
      if (drawer && drawer.contains(e.target)) return;
      if (mega && mega.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-submenu], [data-nav-parent]')) return;
      close();
    }

    function onWindowResize() {
      if (isOpen && isDesktop() && drawer) drawer.setAttribute('aria-hidden', 'true');
      if (isOpen && !isDesktop() && drawer) drawer.setAttribute('aria-hidden', 'false');
      syncMegaA11y(isOpen);
      clearTimeout(headerHeightResizeTimer);
      headerHeightResizeTimer = setTimeout(scheduleHeaderHeights, 120);
    }

    function onDocumentClickCloseNav(e) {
      if (!header) return;
      if (!e.target.closest('[data-nav-parent]')) {
        header.querySelectorAll('[data-nav-parent].is-open').forEach(function (p) {
          p.classList.remove('is-open');
          p.querySelector('[data-submenu-toggle]').setAttribute('aria-expanded', 'false');
          p.querySelector('[data-submenu]').setAttribute('aria-hidden', 'true');
        });
      }
    }

    function handleKeydown(e) {
      if (e.key === 'Escape' && isOpen) { e.preventDefault(); close({ focusMenu: true }); }
    }

    function handleBackdropClick() { if (isOpen) close(); }

    function openChildPanel(panelId) {
      if (!drawer) return;
      var panel = drawer.querySelector('[data-drawer-panel="' + panelId + '"]');
      if (!panel) return;
      activeChildPanel = panel;
      drawer.setAttribute('data-child-open', '');
      panel.classList.add('is-active');
      panel.offsetHeight;
      panel.style.transform = 'translateX(0)';
      panel.querySelectorAll('a, button').forEach(function(el) { el.setAttribute('tabindex', '0'); });
    }

    function closeChildPanel() {
      if (!drawer || !activeChildPanel) return;
      drawer.removeAttribute('data-child-open');
      activeChildPanel.style.transform = '';
      activeChildPanel.classList.remove('is-active');
      activeChildPanel.querySelectorAll('a, button').forEach(function(el) { el.setAttribute('tabindex', '-1'); });
      activeChildPanel = null;
    }

    function initLocale(signal) {
      var toggle = header.querySelector('[data-locale-toggle]');
      var dropdown = header.querySelector('[data-locale-dropdown]');
      if (!toggle || !dropdown) return;
      toggle.addEventListener(
        'click',
        function (e) {
          e.stopPropagation();
          var open = !dropdown.classList.contains('is-open');
          dropdown.classList.toggle('is-open', open);
          toggle.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', String(open));
          dropdown.setAttribute('aria-hidden', String(!open));
        },
        { signal: signal }
      );
      document.addEventListener(
        'click',
        function (e) {
          if (!toggle.contains(e.target) && !dropdown.contains(e.target)) {
            dropdown.classList.remove('is-open');
            toggle.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            dropdown.setAttribute('aria-hidden', 'true');
          }
        },
        { signal: signal }
      );
      document.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'Escape') {
            dropdown.classList.remove('is-open');
            toggle.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            dropdown.setAttribute('aria-hidden', 'true');
          }
        },
        { signal: signal }
      );
    }

    function initMobileCurrency(signal) {
      var cs = header.querySelector('[data-mobile-currency-select]');
      var input = header.querySelector('[data-mobile-currency-input]');
      if (!cs || !input) return;
      input.value = cs.value;
      cs.addEventListener(
        'change',
        function () {
          input.value = this.value;
          var f = this.closest('form');
          if (f) f.submit();
        },
        { signal: signal }
      );
    }

    var cartShakeTimer = null;
    var cartShakeOffTimer = null;

    function stopCartShake() {
      if (cartShakeTimer) {
        clearInterval(cartShakeTimer);
        cartShakeTimer = null;
      }
      if (cartShakeOffTimer) {
        clearTimeout(cartShakeOffTimer);
        cartShakeOffTimer = null;
      }
      if (!header) return;
      var cartEl = header.querySelector('.rz-header__cart');
      if (cartEl) cartEl.classList.remove('is-shaking');
    }

    function startCartShakeBurst(cartEl) {
      if (!cartEl || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      cartEl.classList.add('is-shaking');
      if (cartShakeOffTimer) clearTimeout(cartShakeOffTimer);
      // Shake ~3.5s, then rest until next interval tick
      cartShakeOffTimer = setTimeout(function() {
        cartEl.classList.remove('is-shaking');
        cartShakeOffTimer = null;
      }, 3500);
    }

    function syncCartShake(count) {
      if (!header) return;
      var cartEl = header.querySelector('.rz-header__cart');
      if (!cartEl) return;

      cartEl.classList.toggle('has-items', count > 0);
      stopCartShake();

      if (count <= 0) return;

      // Immediate nudge after add / sync
      startCartShakeBurst(cartEl);
      // Cycle: shake 3–4s, stable ~2.5s → next burst (~6s)
      cartShakeTimer = setInterval(function() {
        startCartShakeBurst(cartEl);
      }, 6000);
    }

    function updateCartCount(count) {
      var n = parseInt(count, 10);
      if (isNaN(n) || n < 0) n = 0;

      var countEls = header.querySelectorAll('[data-cart-count]');
      countEls.forEach(function(countEl) {
        countEl.textContent = n > 0 ? String(n) : '';
        countEl.setAttribute('data-cart-count', String(n));
        countEl.hidden = n === 0;
      });

      var cartEl = header.querySelector('.rz-header__cart');
      if (cartEl) {
        cartEl.setAttribute(
          'aria-label',
          n === 1 ? 'Cart, 1 item' : 'Cart, ' + n + ' items'
        );
      }

      syncCartShake(n);
    }

    function refreshCartCount() {
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          updateCartCount(data.item_count);
        })
        .catch(function () {});
    }

    function onCartLinesUpdate(event) {
      if (event && event.promise && typeof event.promise.then === 'function') {
        event.promise
          .then(function (result) {
            var qty =
              result && result.cart && typeof result.cart.totalQuantity === 'number'
                ? result.cart.totalQuantity
                : result && result.detail && typeof result.detail.itemCount === 'number'
                  ? result.detail.itemCount
                  : null;
            if (qty !== null) {
              updateCartCount(qty);
            } else {
              refreshCartCount();
            }
          })
          .catch(function () {
            refreshCartCount();
          });
        return;
      }
      refreshCartCount();
    }

    function initCart() {
      if (cartListenersBound) {
        refreshCartCount();
        return;
      }
      cartListenersBound = true;
      refreshCartCount();
      document.addEventListener('shopify:cart:lines-update', onCartLinesUpdate);
      document.addEventListener('cart:refresh', refreshCartCount);
      document.addEventListener('cart:updated', refreshCartCount);
      document.addEventListener('cart:update', refreshCartCount);
      document.addEventListener('cart:change', refreshCartCount);
      document.addEventListener('theme-drawer:open', refreshCartCount);
    }

    function initLogoGlb() {
      var viewer = header.querySelector('[data-header-logo-glb]');
      if (!viewer) return;

      var mode = header.getAttribute('data-logo-glb-animation') || '';
      if (mode !== 'glb_native') return;

      var clipName = header.getAttribute('data-logo-glb-native-clip') || '';

      function applyNativeClip() {
        if (clipName && viewer.availableAnimations && viewer.availableAnimations.indexOf(clipName) !== -1) {
          viewer.animationName = clipName;
        } else if (viewer.availableAnimations && viewer.availableAnimations.length) {
          viewer.animationName = viewer.availableAnimations[0];
        }
        viewer.autoplay = true;
        viewer.loop = true;
        if (typeof viewer.play === 'function') {
          viewer.play({ repetitions: Infinity });
        }
      }

      if (viewer.loaded) {
        applyNativeClip();
      } else {
        viewer.addEventListener('load', applyNativeClip, { once: true });
      }
    }

    function initHeaderIntro() {
      if (!header || header.__rzIntroDone) return;
      if (header.getAttribute('data-header-intro') === 'false') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      header.__rzIntroDone = true;

      var targets = [
        header.querySelector('.rz-header__pill--left'),
        header.querySelector('.rz-header__logo'),
        header.querySelector('.rz-header__pill--right')
      ].filter(Boolean);

      targets.forEach(function(el, i) {
        var isLogo = el.classList.contains('rz-header__logo');
        var scale0 = isLogo ? 0.42 : 0.1;
        var delay = 40 + i * 100;

        el.classList.add('is-intro');
        el.style.opacity = '0';
        el.style.transform = isLogo
          ? 'translate3d(0, -48px, 0) scale(' + scale0 + ')'
          : 'translate3d(0, -48px, 0) scaleX(' + scale0 + ')';

        void el.offsetWidth;

        window.setTimeout(function() {
          var frames = isLogo
            ? [
                { transform: 'translate3d(0, -48px, 0) scale(' + scale0 + ')', opacity: 0, offset: 0 },
                { transform: 'translate3d(0, 0, 0) scale(' + scale0 + ')', opacity: 1, offset: 0.34 },
                { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1, offset: 1 }
              ]
            : [
                { transform: 'translate3d(0, -48px, 0) scaleX(' + scale0 + ')', opacity: 0, offset: 0 },
                { transform: 'translate3d(0, 0, 0) scaleX(' + scale0 + ')', opacity: 1, offset: 0.34 },
                { transform: 'translate3d(0, 0, 0) scaleX(1)', opacity: 1, offset: 1 }
              ];

          var motion = el.animate(frames, {
            duration: 1120,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'forwards'
          });

          function done() {
            el.classList.remove('is-intro');
            el.style.opacity = '';
            el.style.transform = '';
            publishHeaderHeights();
          }

          if (motion && motion.finished) {
            motion.finished.then(done).catch(done);
          } else {
            window.setTimeout(done, 1120);
          }
        }, delay);
      });
    }

    function init(section) {
      teardown();

      header = section || document.querySelector('.rz-header');
      if (!header) return;

      abortController = new AbortController();
      var signal = abortController.signal;

      menuBtn = header.querySelector('[data-menu-toggle]');
      drawer = header.querySelector('[data-header-drawer]');
      mega = header.querySelector('[data-header-mega]');
      backdrop = header.querySelector('[data-header-backdrop]');
      drawerLinks = drawer ? drawer.querySelectorAll('[data-drawer-panel="main"] a, [data-drawer-panel="main"] button') : [];

      isOpen = false;
      activeChildPanel = null;
      header.removeAttribute('data-menu-open');
      header.removeAttribute('data-search-open');
      if (drawer) {
        drawer.classList.remove('active');
        drawer.setAttribute('aria-hidden', 'true');
      }
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      drawerLinks.forEach(function (l) {
        l.setAttribute('tabindex', '-1');
      });
      syncMegaA11y(false);
      document.body.style.overflow = '';
      if (window.WMFKNJ.Search && window.WMFKNJ.Search.closeHeader) {
        window.WMFKNJ.Search.closeHeader();
      }

      if (menuBtn) menuBtn.addEventListener('click', toggle, { signal: signal });
      if (backdrop) backdrop.addEventListener('click', handleBackdropClick, { signal: signal });

      document.addEventListener('pointerdown', onPointerDownOutside, { capture: true, signal: signal });

      document.addEventListener('keydown', handleKeydown, { signal: signal });
      document.addEventListener('keydown', trapDrawerFocus, { signal: signal });
      window.addEventListener('resize', onWindowResize, { signal: signal });

      initScrollHide(signal);
      initHeaderIntro();
      scheduleHeaderHeights();

      header.querySelectorAll('[data-header-back]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          // Always collapse header chrome first — user must re-open menu/search
          closeAllChrome();

          // Product feed deep-link only — otherwise real browser back
          var params = new URLSearchParams(window.location.search);
          var from = params.get('from');
          var isProduct = !!(
            document.querySelector('[data-rz-pdp]') ||
            document.body.classList.contains('template-product')
          );

          if (isProduct && from === 'feed') {
            var stored = '';
            try { stored = sessionStorage.getItem('rz-feed-return') || ''; } catch (err) {}
            var fallback = '/collections/all';
            var dest = stored && stored.charAt(0) === '/' ? stored : fallback;
            if (dest === '/' || dest === '') dest = fallback;
            window.location.href = dest;
            return;
          }

          if (window.history.length > 1) {
            window.history.back();
            return;
          }
          window.location.href = '/';
        }, { signal: signal });
      });

      window.addEventListener('pagehide', closeAllChrome, { signal: signal });
      window.addEventListener('pageshow', closeAllChrome, { signal: signal });
      window.addEventListener('popstate', closeAllChrome, { signal: signal });

      header.querySelectorAll('[data-submenu-toggle]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          var parent = btn.closest('[data-nav-parent]');
          var wasOpen = parent.classList.contains('is-open');
          header.querySelectorAll('[data-nav-parent].is-open').forEach(function(p) {
            p.classList.remove('is-open');
            p.querySelector('[data-submenu-toggle]').setAttribute('aria-expanded', 'false');
            p.querySelector('[data-submenu]').setAttribute('aria-hidden', 'true');
          });
          if (!wasOpen) {
            parent.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            parent.querySelector('[data-submenu]').setAttribute('aria-hidden', 'false');
          }
        }, { signal: signal });
      });

      document.addEventListener('click', onDocumentClickCloseNav, { signal: signal });

      if (drawer) {
        drawer.querySelectorAll('[data-drawer-to]').forEach(function(btn) {
          btn.addEventListener(
            'click',
            function () {
              openChildPanel(btn.getAttribute('data-drawer-to'));
            },
            { signal: signal }
          );
        });
        drawer.querySelectorAll('[data-drawer-back]').forEach(function(btn) {
          btn.addEventListener('click', closeChildPanel, { signal: signal });
        });
      }

      initLocale(signal);
      initMobileCurrency(signal);
      initCart();
      initLogoGlb();
    }

    function destroy() {
      if (header) closeAllChrome();
      teardown();
    }

    return { init: init, destroy: destroy, close: close, closeAllChrome: closeAllChrome };
  })();

  document.addEventListener('DOMContentLoaded', function() {
    window.WMFKNJ.Header.init();
    initAnnouncementRotate();
  });

  function initAnnouncementRotate() {
    var roots = document.querySelectorAll('[data-announcement-rotate]');
    roots.forEach(function(root) {
      if (root.dataset.announcementRotateBound === '1') return;
      root.dataset.announcementRotateBound = '1';
      var items = root.querySelectorAll('[data-announcement-item]');
      if (items.length < 2) return;
      var idx = 0;
      var interval = parseInt(root.closest('.rz-announcement')?.getAttribute('data-rotate-interval'), 10) || 5000;
      setInterval(function() {
        items[idx].classList.remove('is-active');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active');
      }, interval);
    });
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('.rz-header');
      if (section) {
        section.__rzIntroDone = false;
        window.WMFKNJ.Header.destroy();
        window.WMFKNJ.Header.init(section);
      }
    });
    document.addEventListener('shopify:section:unload', function(e) {
      if (e.target.querySelector('.rz-header')) window.WMFKNJ.Header.destroy();
    });
  }
